<template>
  <b-container :fluid="true"
               class="mb-2 pa-0">
    <b-card v-if="isCallValid"
            class="mb-2 mt-2">
      <shifts-counter v-model="shiftsCounterData"
                      :beamlines="mergedBeamlines"
                      :call-data="endStations"
                      :infrastructure="infrastructure"
                      :isManagementEvaluation="isManagementEvaluation"
                      :proposals="proposals"/>
    </b-card>
  </b-container>
</template>

<!--In this component data needed to shifts counter are prepared.-->

<script>
  import { mapState } from 'vuex';
  import beamlines from '@/json/beamlines';
  import beamlinesLegacy from '@/json/beamlinesLegacy';
  import ShiftsCounter from '@/components/shifts-counter/ShiftsCounter';
  import _ from 'lodash';

  export default {
    name: 'ShiftsCounterWrapper',
    components: { ShiftsCounter },
    props: {
      callName: {
        type: String,
        default: '',
      },
      infrastructure: {
        type: String,
        required: true,
      },
      proposals: {
        type: Array,
        required: true,
      },
      isManagementEvaluation: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        shiftsCounterData: {},
        environments: [],
        beamlines,
        beamlinesLegacy,
      };
    },
    computed: {
      ...mapState('calls', ['calls']),
      call() {
        return this.calls.find((el) => el.name === this.callName);
      },
      callDataWithShifts() {
        let callData = {};
        if (this.hasProperty(this.call, 'data')) {
          callData = JSON.parse(JSON.stringify(this.call.data));
        }
        this.call.environments.forEach((el) => {
          if (callData[el]) {
            callData[el] = {
              shifts: this.hasProperty(callData[el], 'shifts') ? Number(callData[el].shifts) : 0,
              shiftsManagement: this.hasProperty(callData[el], 'shifts_management')
                ? Number(callData[el].shifts_management) : 0,
              shiftsReserve: this.hasProperty(callData[el], 'shifts_reserve')
                ? Number(callData[el].shifts_reserve) : 0,
            };
          } else {
            callData[el] = { shifts: 0, shiftsManagement: 0, shiftsReserve: 0 };
          }
        });
        return callData;
      },
      endStations() {
        this.getEnvironments();
        if (this.isCallValid) {
          const options = { ...this.callDataWithShifts };
          Object.keys(options).forEach((el) => {
            if (!this.environments.includes(el)) {
              delete options[el];
            }
          });
          return options;
        }
        return {};
      },
      isCallValid() {
        return !this.isEmpty(this.call);
      },
      mergedBeamlines() {
        const mergedBeamlines = _.cloneDeep(this.beamlines);
        Object.entries(this.beamlinesLegacy).forEach(([beamline, endstations]) => {
          mergedBeamlines[beamline] = mergedBeamlines[beamline].concat(endstations);
        });
        return mergedBeamlines;
      },
    },
    watch: {
      shiftsCounterData() {
        this.$emit('input', this.shiftsCounterData);
      },
    },
    created() {
      if (!this.$store.state.calls.calls.length) {
        this.$store.dispatch('calls/load_calls');
      }
      this.getEnvironments();
    },
    methods: {
      getEnvironments() {
        if (this.infrastructure === 'synchrotron') {
          const endstations = Object.values(this.beamlines).flat();
          const legacyEndstations = Object.values(this.beamlinesLegacy).flat();
          this.environments = endstations.concat(legacyEndstations);
        } else {
          this.environments = ['CRYOEM'];
        }
      },
    },
  };

</script>
